module.exports = __webpack_public_path__ + "static/media/a-3-c.d9ffd01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-3-c.jpg
// module id = 1098
// module chunks = 33